import {observer} from 'mobx-react';
import React from 'react';
import {LanguageListStore} from '../LanguageListStore';

@observer
export class AddLanguageForm extends React.Component<{ store: LanguageListStore }> {
  render() {
    const {store} = this.props;

    if (store.addLanguage === null)
      return null;

    const name = store.addLanguage.name;

    return (
      <div className="row" key="add-form">
        <div className="col">
          <div className={name.formGroupClassName}>
            <input className="form-control" type="text"
                   value={name.value}
                   onChange={name.onChangeHandler}
                   onKeyDown={store.completeOnEnter}
                   onBlur={name.markTouched}/>
            <div className="invalid-text">Enter name</div>
          </div>
        </div>
      </div>);
  }
}
